import { Box, BoxProps, Image } from "@chakra-ui/react";
import XlsIcon from "./xls-icon.svg";

export function XlsxIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <Image src={XlsIcon} />
    </Box>
  );
}
